<template>
	<template v-if="data">
		<section>
			<ButtonBack />

			<el-row class="titlerow" :class="data.case ? 'no-margin' : ''">
				<el-col :sm="12">
					<h1>{{ data.title }}</h1>
				</el-col>
				<el-col :sm="12">
					<div :class="`has-status has-status--${$getStateColor('statement', data.state)}`">
						{{ $getStateFullLabel('statement', data.state, false) }}
					</div>
				</el-col>
			</el-row>

			<RouterLink :to="'/fall/' + data.case?.id" :title="'Zugeordneten Fall anzeigen'" class="link" v-if="data.case && data.case.id">
				Zugeordneten Fall anzeigen
			</RouterLink>

			<TheBox :title="'Stellungnahme:'">
				<div class="text">{{ data.answer ? data.answer : '-' }}</div>
			</TheBox>

			<TheBox :title="'Stellungnahme Infos'" :hasDataGrid="true">
				<el-row>
					<el-col :sm="12" :xs="24">
						<el-form-item label="Titel Stellungnahme:" prop="title">
							<span>{{ data.title }}</span>
						</el-form-item>

						<el-form-item label="Stn.-Gruppe:">
							<span>{{ data.contact?.roles?.length > 0 ? data.contact.roles.map((r) => r.name).join(', ') : '-' }}</span>
						</el-form-item>

						<el-form-item label="Stn. angefordert:">
							<span>{{ $formatDate(data.createdDate) }}</span>
						</el-form-item>

						<el-form-item label="Stn. erhalten:">
							<span>{{ data.answeredDate ? $formatDate(data.answeredDate) : '-' }}</span>
						</el-form-item>
					</el-col>

					<el-col :sm="12" :xs="24">
						<el-form-item label="Frist bis:">
							<span>{{ data.lastValidDate ? $formatDate(data.lastValidDate) : $formatDate(data.firstValidDate) }}</span>
						</el-form-item>

						<el-form-item label="Frist verlängert">
							<span>{{ data.lastValidDate ? 'Ja' : 'Nein' }}</span>
						</el-form-item>

						<el-form-item label="Frist Verlängerung bis:">
							<span>{{ data.lastValidDate ? $formatDate(data.lastValidDate) : '-' }}</span>
						</el-form-item>

						<el-form-item label="ID:">
							<span>{{ data.hid }}</span>
						</el-form-item>
					</el-col>
				</el-row>
			</TheBox>
		</section>

		<DetailsMedia
			v-if="statementFiles.length > 0"
			:files="statementFiles"
			@addToFiles="null"
			@removeFromFiles="null"
			:showAddButton="false"
			:pageType="'stellungnahme'"
		/>

		<DetailsLinks
			v-if="statementLinks.length > 0"
			:links="statementLinks"
			@addToLinks="null"
			@removeFromLinks="null"
			:showAddButton="false"
			:pageType="'stellungnahme'"
		/>
	</template>
	<section v-else-if="loading === false">
		<ButtonBack />
		<el-alert :title="texts.general.emptyText" type="error" effect="dark" :closable="false" />
	</section>
</template>

<script lang="ts">
import { defineComponent, ref, markRaw } from 'vue';
import { Plus, Loading } from '@element-plus/icons-vue';

import ButtonBack from '../components/buttons/ButtonBack.vue';
import TheBox from '../components/TheBox.vue';
import TheButton from '../components/TheButton.vue';

import { getStatement } from '@/requests/statements';
import { startLoading, stopLoading } from '@/utils/loading/loadingHandler';
import { DetailFile, DetailLink, StatementResponse } from '../types/types';
import { texts } from '../utils/texts.js';
import DetailsLinks from './sections/DetailsLinks.vue';
import DetailsMedia from './sections/DetailsMedia.vue';

export default defineComponent({
	name: 'StellungnahmeDetailWerberat',
	data() {
		return {
			data: null as StatementResponse | null,
			loading: true,
			statementFiles: [] as DetailFile[],
			statementLinks: [] as DetailLink[],
		};
	},
	props: {
		id: {
			type: String,
			required: true,
		},
	},
	components: {
		ButtonBack,
		TheButton,
		TheBox,
		Plus,
		Loading,
		DetailsMedia,
		DetailsLinks,
	},
	computed: {
		texts() {
			return texts;
		},
	},
	methods: {
		async loadStatement() {
			const loading = startLoading('#stellungnahme');

			const result = await getStatement(this.id);
			if (result.success) {
				this.data = result.data;

				this.statementLinks = this.data.links.map((l) => {
					return { link: l, isNew: false } as DetailLink;
				});
				this.statementFiles = this.data.files.map((f) => {
					return { file: f, isNew: false } as DetailFile;
				});
			}

			this.loading = false;
			stopLoading(loading);
		},
	},
	mounted() {
		this.loadStatement();
	},
});
</script>
